// services/fetchEventData.js

import EventStructure from "../Constants/CommonImageStructureOnEvent";

// ==================== SHARED FORMATTER ====================

const formatEventData = (data) => ({
  ...EventStructure,
  eventId:           data.eventId           || "",
  eventuuid:         data.eventuuid         || "",
  eventname:         data.eventname         || "",
  country:           data.country           || "",
  religion:          data.religion          || "",
  eventtype:         data.eventtype         || "",
  eventcoverimage:   data.eventcoverimage   || "",
  eventprofileimage: data.eventprofileimage || "",
  pincode:           data.pincode           || "",
  createdOn:         data.createdOn         || "",
  lastUpdate:        data.lastUpdate        || "",
  eventcycle:        data.eventcycle        || "",

  advertises: (data.advertises || []).map((ad) => ({
    advertiseId:       ad.advertiseId       || "",
    advertiseUUID:     ad.advertiseUUID     || "",
    profileId:         ad.profileId         || "",
    advertiseImageUrl: ad.advertiseImageUrl || "",
    PlannedDate:       ad.PlannedDate       || "",
    postedBy:          ad.postedBy          || "",
    postedOn:          ad.postedOn          || "",
  })),

  users: (data.users || []).map((user) => ({
    userId:      user.userId      || "",
    userUUID:    user.userUUID    || "",
    userName:    user.userName    || "",
    location:    user.location    || "",
    nationality: user.nationality || "",
    religion:    user.religion    || "",
    joinedOn:    user.joinedOn    || "",
    lastupdate:  user.lastupdate  || "",
  })),

  eventspec: (data.eventspec || []).map((spec) => ({
    foodName:     spec.foodName     || "",
    foodtype:     spec.foodtype     || "",
    foodCategory: spec.foodCategory || "",
    acceptancy:   spec.acceptancy   || "",
  })),

  feeds: (data.feeds || []).map((feed) => ({
    postId:       feed.postId       || "",
    userId:       feed.userId       || "",
    useruuid:     feed.useruuid     || "",
    userimage:    feed.userimage    || "",
    userName:     feed.userName     || "",
    descriptions: feed.descriptions || "",
    timestamp:    feed.timestamp    || "",
    nlikes:       feed.nlikes       || 0,
    nshares:      feed.nshares      || 0,

    locations: (feed.locations || []).map((loc) => ({
      locationId:   loc.locationId   || "",
      locationUUID: loc.locationUUID || "",
      profileImage: loc.profileImage || "",
      vulanteers: (loc.vulanteers || []).map((v) => ({
        userid:    v.userid    || "",
        useruuid:  v.useruuid  || "",
        username:  v.username  || "",
        userimage: v.userimage || "",
      })),
    })),

    medias: (feed.medias || []).map((media) => ({
      mediaId:      media.mediaId      || "",
      mediauuid:    media.mediauuid    || "",
      descriptions: media.descriptions || "",
      uploadedBy:   media.uploadedBy   || "",
      mediasize:    media.mediasize    || "",
      mediatype:    media.mediatype    || "",
      imageurl:     media.imageurl     || "",
      nlikes:       media.nlikes       || 0,
      nshares:      media.nshares      || 0,
      nsuggests:    media.nsuggests    || 0,
      comments: (media.comments || []).map((c) => ({
        userId:    c.userId    || "",
        comment:   c.comment   || "",
        timestamp: c.timestamp || "",
        location:  c.location  || "",
      })),
    })),

    comments: (feed.comments || []).map((c) => ({
      userId:    c.userId    || "",
      comment:   c.comment   || "",
      timestamp: c.timestamp || "",
      location:  c.location  || "",
    })),
  })),
});

// ==================== SHARED HTTP FETCH ====================

const fetchFromUrl = async (url) => {
  console.log(`[fetchEventData] GET → ${url}`);
  const response = await fetch(url);
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  const data = await response.json();
  const formattedData = formatEventData(data);
  console.log("[fetchEventData] formattedData:", formattedData);
  return formattedData;
};

// ==================== MEDIA EXTRACTOR ====================

export const extractMediaByType = (formattedData, contentType) => {
  if (!formattedData?.feeds) return [];

  const typeMap = {
    images: "image",
    reels:  "reel",
    videos: "video",
  };
  const targetType = typeMap[contentType] || contentType;

  return formattedData.feeds.flatMap((feed) =>
    (feed.medias || [])
      .filter((m) =>
        m.mediatype === targetType ||
        m.mediatype.startsWith(`${targetType}/`)
      )
      .map((media) => ({
        id:          media.mediaId,
        imageurl:    media.imageurl,
        description: media.descriptions,
        posted_by:   feed.userName || media.uploadedBy || "Anonymous",
        user_avatar: feed.userimage,
        timestamp:   feed.timestamp,
        location:    feed.locations?.[0]?.locationId || "",
        impressions: media.nlikes,
        mediatype:   media.mediatype,
      }))
  );
};

// ==================== MODE-SPECIFIC FETCHERS ====================

const BASE = "/api/mock/EventPage";

// Mode: userid-eventid
export const fetchEventData = async (eventId, year) =>
  fetchFromUrl(`${BASE}/UserEventPageMockData-${eventId}-${year}.json`);

// Mode: eventid-only
export const fetchEventIdOnly = async (eventId) =>
  fetchFromUrl(`${BASE}/UserEventPageMockData-${eventId}.json`);

// Mode: societyid-eventid
export const fetchSocietyIdEventId = async (societyId, eventId) =>
  fetchFromUrl(`${BASE}/UserEventPageMockData-${societyId}-${eventId}.json`);

// Mode: eventname-year
export const fetchEventNameYear = async (eventName, year) =>
  fetchFromUrl(`${BASE}/UserEventPageMockData-${eventName}-${year}.json`);

// Mode: userid-eventname-year
export const fetchUserIdEventNameYear = async (userId, eventName, year) =>
  fetchFromUrl(`${BASE}/UserEventPageMockData-${userId}-${eventName}-${year}.json`);

// ✅ NEW Mode: userid-societyid-eventid
export const fetchUserIdSocietyIdEventId = async (userId, societyId, eventId) =>
  fetchFromUrl(`${BASE}/UserEventPageMockData-${userId}-${societyId}-${eventId}.json`);
